(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomo-cart"]) return;
  try {
    
if (!customElements.get('nomo-cart')) {
  customElements.define('nomo-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.root = window.Shopify?.routes?.root || '/';
      this.busy = false;
      this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = this.previousOverflow || ''; this.previousFocus?.focus({preventScroll:true}); });
      this.querySelector('[data-nomo-cart-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if(event.target === this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left)this.dialog.close();} });
      document.addEventListener('click', event => {
        const trigger=event.target.closest('[data-nomo-cart-open]');
        if(trigger){event.preventDefault();this.open();return;}
        const change=event.target.closest('[data-cart-change]');
        if(change){event.preventDefault();this.change(change.dataset.cartChange,Number(change.dataset.quantity));return;}
        const add=event.target.closest('[data-cart-add-ring]');
        if(add){event.preventDefault();const select=add.closest('.nomo-cart-upsell').querySelector('[data-cart-ring-variant]');this.add(Number(select.value));}
      });
      document.addEventListener('change', event => {
        if(event.target.matches('[data-cart-protection]')){const input=event.target;if(input.checked)this.add(Number(input.dataset.variantId));else if(input.dataset.lineKey)this.change(input.dataset.lineKey,0);}
        if(event.target.matches('[data-cart-ring-variant]'))event.target.closest('.nomo-cart-upsell').querySelector('img').src=event.target.selectedOptions[0].dataset.image;
      });
      this.ticker = setInterval(() => this.tick(),1000);
      try { if (Number(this.querySelector('[data-nomo-cart-body]')?.dataset.itemCount) > 0 && !localStorage.getItem('nomo-cart-reservation-until')) localStorage.setItem('nomo-cart-reservation-until', String(Date.now()+600000)); } catch (_) {}
      this.tick();
    }
    disconnectedCallback(){clearInterval(this.ticker);}
    async open(){
      this.previousFocus=document.activeElement;
      try {await this.refresh();}catch(_){window.location.assign(this.root+'cart');return;}
      const other=document.querySelector('dialog[open]');if(other && other!==this.dialog)other.close();
      this.previousOverflow=document.documentElement.style.overflow;
      this.dialog.showModal();document.documentElement.style.overflow='hidden';this.tick();
    }
    async refresh(){
      const response=await fetch(this.root+'?sections='+encodeURIComponent(this.dataset.sectionId),{headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Cart refresh failed');
      const sections=await response.json();this.render(sections[this.dataset.sectionId]);
    }
    render(html){
      if(!html)throw new Error('Missing cart section');
      const doc=new DOMParser().parseFromString(html,'text/html');const body=doc.querySelector('[data-nomo-cart-body]');
      if(!body)throw new Error('Missing cart body');
      document.querySelectorAll('[data-nomo-cart-body]').forEach(old=>old.replaceWith(body.cloneNode(true)));
      document.querySelectorAll('[data-nomo-cart-count]').forEach(el=>el.textContent=body.dataset.itemCount);
      document.querySelectorAll('[data-nomo-cart-unit]').forEach(el=>el.textContent=Number(body.dataset.itemCount)===1?el.dataset.one:el.dataset.many);
      try{
        if(Number(body.dataset.itemCount)===0)localStorage.removeItem('nomo-cart-reservation-until');
        else if(!localStorage.getItem('nomo-cart-reservation-until'))localStorage.setItem('nomo-cart-reservation-until',String(Date.now()+600000));
      }catch(_){}
      this.tick();
    }
    tick(){
      let end;try{end=Number(localStorage.getItem('nomo-cart-reservation-until'));}catch(_){}
      if(!end){this.fallbackEnd=this.fallbackEnd||Date.now()+600000;end=this.fallbackEnd;}
      const remaining=Math.max(0,Math.ceil((end-Date.now())/1000));
      document.querySelectorAll('[data-reservation-clock]').forEach(el=>{
        const bar=el.closest('.nomo-cart-reservation');if(remaining===0){bar.classList.add('is-expired');bar.querySelector('span:last-child').textContent=this.dataset.expired;}
        else el.textContent=String(Math.floor(remaining/60)).padStart(2,'0')+':'+String(remaining%60).padStart(2,'0');
      });
    }
    async change(key,quantity){await this.mutate('change',{id:key,quantity});}
    async add(id){try{localStorage.setItem('nomo-cart-reservation-until',String(Date.now()+600000));}catch(_){}await this.mutate('add',{items:[{id,quantity:1}]});}
    async mutate(action,payload){
      if(this.busy)return;this.busy=true;
      document.querySelectorAll('[data-nomo-cart-body]').forEach(el=>el.setAttribute('aria-busy','true'));
      try{
        const response=await fetch(this.root+'cart/'+action+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...payload,sections:[this.dataset.sectionId],sections_url:this.root+'cart'})});
        const data=await response.json();if(!response.ok)throw new Error('Cart change failed');
        if(data.sections?.[this.dataset.sectionId])this.render(data.sections[this.dataset.sectionId]);else await this.refresh();
      }catch(_){try{await this.refresh();}catch(_){}document.querySelectorAll('[data-nomo-cart-error]').forEach(el=>el.hidden=false);}
      finally{this.busy=false;document.querySelectorAll('[data-nomo-cart-body]').forEach(el=>el.removeAttribute('aria-busy'));}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomo-home-clips"] && !Shopify.designMode) return;
  try {
    
// Clips play only while on screen (muted), and pause off screen to save data.
(() => {
  const init = () => document.querySelectorAll('[data-nh-clips]').forEach(rail => {
    if (rail.dataset.nhReady) return;
    rail.dataset.nhReady = '1';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const videos = [...rail.querySelectorAll('video')];
    const sync = () => {
      const r = rail.getBoundingClientRect();
      const railVisible = r.bottom > 0 && r.top < window.innerHeight;
      videos.forEach(video => {
        const v = video.getBoundingClientRect();
        const visible = railVisible && v.right > 0 && v.left < window.innerWidth;
        if (visible && !reduce) { video.preload = 'auto'; video.muted = true; video.play().catch(() => {}); }
        else video.pause();
      });
    };
    let t;
    const queue = () => { clearTimeout(t); t = setTimeout(sync, 120); };
    window.addEventListener('scroll', queue, {passive: true});
    rail.addEventListener('scroll', queue, {passive: true});
    window.addEventListener('resize', queue);
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomo-keyring-product"]) return;
  try {
    
document.querySelectorAll('[data-ring-product-variant]').forEach(select => select.addEventListener('change', () => {
  const image = select.closest('.nomo-ring-product').querySelector('[data-ring-product-image]');
  image.src = select.selectedOptions[0].dataset.image;
}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomo-scratch-popup"]) return;
  try {
    
if (!customElements.get('nomo-scratch')) {
  customElements.define('nomo-scratch', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      if (!dialog || !dialog.showModal) { this.hidden = true; return; }
      const intro = this.querySelector('[data-scratch-intro]');
      const email = this.querySelector('[data-scratch-email]');
      const card = this.querySelector('[data-scratch-card]');
      const canvas = this.querySelector('canvas');
      const launch = this.querySelector('[data-scratch-open]');
      const success = this.querySelector('[data-scratch-success]');
      const errors = this.querySelector('[data-scratch-errors]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let previousFocus;
      let oldOverflow = '';
      const read = key => { try { return localStorage.getItem(key); } catch (_) { return null; } };
      const write = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };

      // Launcher appears once the visitor scrolls past roughly the first screen.
      const threshold = () => Math.min(600, window.innerHeight * 0.6);
      let ticking = false;
      const syncLaunch = () => { ticking = false; launch.classList.toggle('is-visible', window.scrollY > threshold()); };
      this.onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(syncLaunch); } };
      window.addEventListener('scroll', this.onScroll, {passive:true});
      syncLaunch();

      const open = () => {
        if (dialog.open || document.querySelector('dialog[open]')) return;
        previousFocus = document.activeElement;
        oldOverflow = document.documentElement.style.overflow;
        dialog.classList.remove('is-closing');
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      };
      const close = () => {
        if (!dialog.open || dialog.classList.contains('is-closing')) return;
        if (reduced) { dialog.close(); return; }
        dialog.classList.add('is-closing');
        let done = false;
        const finish = () => { if (done) return; done = true; dialog.classList.remove('is-closing'); dialog.close(); };
        dialog.addEventListener('animationend', event => { if (event.target === dialog) finish(); }, {once:true});
        setTimeout(finish, 400);
      };
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = oldOverflow;
        write('nomo-scratch-dismissed-v1', String(Date.now()));
        previousFocus?.focus({preventScroll:true});
      });
      this.querySelectorAll('[data-scratch-close]').forEach(button => button.addEventListener('click', close));
      launch.addEventListener('click', open);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
      });

      const confetti = () => {
        if (reduced || !card.animate) return;
        const colors = ['#173a32', '#a7c4b5', '#c9a35a', '#e8cf8a', '#a96346'];
        for (let i = 0; i < 32; i++) {
          const piece = document.createElement('span');
          piece.className = 'nomo-scratch-confetti';
          piece.style.background = colors[i % colors.length];
          card.appendChild(piece);
          const angle = Math.random() * Math.PI * 2;
          const distance = 110 + Math.random() * 170;
          const x = Math.cos(angle) * distance;
          const y = Math.sin(angle) * distance * .65 - 40;
          piece.animate([
            {transform:'translate(-50%,-50%) rotate(0deg) scale(.4)', opacity:1},
            {transform:`translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) rotate(${Math.random() * 540 - 270}deg) scale(1)`, opacity:1, offset:.6},
            {transform:`translate(calc(-50% + ${x * 1.1}px), calc(-50% + ${y + 90}px)) rotate(${Math.random() * 720 - 360}deg) scale(.9)`, opacity:0}
          ], {duration:1150 + Math.random() * 500, easing:'cubic-bezier(.2,.8,.3,1)'}).onfinish = () => piece.remove();
        }
      };
      const reveal = () => {
        if (card.classList.contains('is-revealed')) return;
        card.classList.remove('is-scratching');
        card.classList.add('is-revealed');
        this.querySelector('.nomo-scratch-reward').removeAttribute('aria-hidden');
        this.querySelector('[data-scratch-claim]').hidden = false;
        this.querySelector('[data-scratch-reveal]').hidden = true;
        try { navigator.vibrate?.(18); } catch (_) {}
        confetti();
        setTimeout(() => { canvas.hidden = true; }, 600);
      };
      this.querySelector('[data-scratch-reveal]').addEventListener('click', reveal);
      this.querySelector('[data-scratch-claim]').addEventListener('click', () => {
        intro.hidden = true;
        email.hidden = false;
        this.querySelector('#NomoScratchEmail')?.focus({preventScroll:true});
      });

      const ctx = canvas.getContext('2d', {willReadFrequently:true});
      if (ctx) {
        const W = canvas.width, H = canvas.height;
        // Gold foil: layered gradients, brushed grain and a few scratch strokes as a hint.
        const base = ctx.createLinearGradient(0, 0, W, H);
        base.addColorStop(0, '#b8913f'); base.addColorStop(.22, '#e9d08c'); base.addColorStop(.45, '#c9a35a');
        base.addColorStop(.68, '#f1dc9f'); base.addColorStop(.85, '#c39a4c'); base.addColorStop(1, '#a8833a');
        ctx.fillStyle = base; ctx.fillRect(0, 0, W, H);
        const glow = ctx.createRadialGradient(W * .3, H * .2, 10, W * .3, H * .2, W * .7);
        glow.addColorStop(0, 'rgba(255,248,220,.45)'); glow.addColorStop(1, 'rgba(255,248,220,0)');
        ctx.fillStyle = glow; ctx.fillRect(0, 0, W, H);
        for (let i = 0; i < 2600; i++) {
          ctx.fillStyle = Math.random() > .5 ? 'rgba(255,245,210,.10)' : 'rgba(110,80,25,.08)';
          ctx.fillRect(Math.random() * W, Math.random() * H, 1 + Math.random() * 2, 1 + Math.random() * 2);
        }
        ctx.strokeStyle = 'rgba(255,250,230,.06)'; ctx.lineWidth = 1;
        for (let y = 0; y < H; y += 3) { ctx.beginPath(); ctx.moveTo(0, y + Math.random() * 2); ctx.lineTo(W, y + Math.random() * 2); ctx.stroke(); }
        ctx.save();
        ctx.translate(W / 2, H / 2); ctx.rotate(-.12);
        ctx.fillStyle = 'rgba(120,90,30,.22)';
        [-210, -120, -30, 60, 150].forEach((x, i) => {
          ctx.save(); ctx.translate(x, (i % 2 ? 14 : -8)); ctx.rotate(.32 + (i % 2 ? .06 : -.04));
          ctx.beginPath(); ctx.roundRect ? ctx.roundRect(-30, -120, 60, 240, 18) : ctx.rect(-30, -120, 60, 240); ctx.fill(); ctx.restore();
        });
        ctx.restore();
        const sans = getComputedStyle(this).getPropertyValue('--nb-font-sans').trim() || 'sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = `700 76px ${sans}`;
        if ('letterSpacing' in ctx) ctx.letterSpacing = '2px';
        ctx.shadowColor = 'rgba(110,80,25,.35)'; ctx.shadowOffsetY = 3; ctx.shadowBlur = 6;
        ctx.fillStyle = 'rgba(255,252,240,.82)';
        ctx.fillText(this.dataset.canvasLabel.toUpperCase(), W / 2, H / 2 + 4);
        ctx.shadowColor = 'transparent';

        let active = false, last = null, strokes = 0, dustTick = 0;
        const point = e => { const r = canvas.getBoundingClientRect(); return {x:(e.clientX - r.left) * W / r.width, y:(e.clientY - r.top) * H / r.height, cx:e.clientX - r.left, cy:e.clientY - r.top}; };
        const dust = p => {
          if (reduced || !card.animate || ++dustTick % 2) return;
          const fleck = document.createElement('span');
          fleck.className = 'nomo-scratch-dust';
          fleck.style.left = p.cx + 'px'; fleck.style.top = p.cy + 'px';
          card.appendChild(fleck);
          const dx = (Math.random() - .5) * 50, dy = 20 + Math.random() * 40;
          fleck.animate([{transform:'translate(-50%,-50%) rotate(0)', opacity:.95}, {transform:`translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${Math.random() * 360}deg)`, opacity:0}], {duration:650, easing:'cubic-bezier(.3,.6,.4,1)'}).onfinish = () => fleck.remove();
        };
        const checkCleared = () => {
          const pixels = ctx.getImageData(0, 0, W, H).data; let empty = 0, total = 0;
          for (let i = 3; i < pixels.length; i += 96) { total++; if (pixels[i] < 128) empty++; }
          if (empty / total > .45) reveal();
        };
        const erase = e => {
          const p = point(e);
          ctx.globalCompositeOperation = 'destination-out'; ctx.strokeStyle = '#000'; ctx.fillStyle = '#000'; ctx.globalAlpha = 1; ctx.lineWidth = 90; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
          ctx.beginPath(); ctx.moveTo(last?.x ?? p.x, last?.y ?? p.y); ctx.lineTo(p.x, p.y); ctx.stroke();
          ctx.beginPath(); ctx.arc(p.x, p.y, 45, 0, Math.PI * 2); ctx.fill();
          last = p; dust(p);
          if (++strokes % 5 === 0) checkCleared();
        };
        canvas.addEventListener('pointerdown', e => { active = true; last = null; card.classList.add('is-scratching'); canvas.setPointerCapture(e.pointerId); erase(e); });
        canvas.addEventListener('pointermove', e => { if (active) erase(e); });
        const stop = () => { if (active) checkCleared(); active = false; last = null; };
        canvas.addEventListener('pointerup', stop); canvas.addEventListener('pointercancel', stop);
      } else reveal();

      this.querySelector('[data-scratch-copy]')?.addEventListener('click', async event => {
        const button = event.currentTarget;
        try { await navigator.clipboard.writeText(this.querySelector('[data-scratch-code]').textContent.trim()); button.textContent = button.dataset.copied; }
        catch (_) { const selection = window.getSelection(); const range = document.createRange(); range.selectNodeContents(this.querySelector('[data-scratch-code]')); selection.removeAllRanges(); selection.addRange(range); }
      });
      this.querySelector('form')?.addEventListener('submit', event => {
        if (!event.target.checkValidity()) return;
        const button = event.target.querySelector('[type=submit]'); if (button) { button.disabled = true; button.textContent = button.dataset.pending; }
      });
      if (success || errors) { intro.hidden = true; email.hidden = false; open(); if (success) write('nomo-scratch-claimed-v1', '1'); }
      else if (read('nomo-scratch-claimed-v1')) launch.hidden = true;
      else if (!window.Shopify?.designMode && Date.now() - Number(read('nomo-scratch-dismissed-v1') || 0) > 7 * 86400000) {
        this.timer = setTimeout(() => { if (document.visibilityState === 'visible') open(); }, Number(this.dataset.delay || 12) * 1000);
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); window.removeEventListener('scroll', this.onScroll); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["see-it-in-action"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('nomo-image-compare')) {
  customElements.define('nomo-image-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.range = this.querySelector('[data-compare-range]');
      this.stage = this.querySelector('[data-compare-stage]');
      if (!this.range || !this.stage) return;
      const update = () => {
        const value = Math.min(100, Math.max(0, Number(this.range.value)));
        this.style.setProperty('--compare-position', value + '%');
        this.range.setAttribute('aria-valuetext', (this.dataset.valueTemplate || '{folded}% keychain, {open}% tote').replace('{folded}', value).replace('{open}', 100 - value));
        this.querySelectorAll('[data-compare-to]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.compareTo) === value)));
      };
      const move = event => {
        const bounds = this.stage.getBoundingClientRect();
        if (bounds.width) this.range.value = String(Math.round(Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width)) * 100));
        update();
      };
      this.range.addEventListener('input', update, options);
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.pointerId = event.pointerId;
        this.stage.setPointerCapture(event.pointerId);
        this.range.focus({ preventScroll: true });
        move(event);
      }, options);
      this.stage.addEventListener('pointermove', event => { if (event.pointerId === this.pointerId) move(event); }, options);
      const release = event => {
        if (event.pointerId !== this.pointerId) return;
        this.pointerId = null;
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
      };
      this.stage.addEventListener('pointerup', release, options);
      this.stage.addEventListener('pointercancel', release, options);
      this.stage.addEventListener('lostpointercapture', () => { this.pointerId = null; }, options);
      this.querySelectorAll('[data-compare-to]').forEach(button => button.addEventListener('click', () => {
        this.range.value = button.dataset.compareTo;
        update();
      }, options));
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.pointerId = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
